var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "geolocation-component" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "expand geolocation-dialog",
            persistent: ""
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c(
                "v-layout",
                { attrs: { "align-center": "" } },
                [
                  _c("v-flex", [
                    _vm.message.errorCode !== "softGeolocation" &&
                    _vm.message.errorCode !== "softGeolocationRedirect" &&
                    _vm.message.errorCode !== "hardGeolocationRedirect"
                      ? _c("h1", [
                          _vm._v(
                            _vm._s(_vm.$t("Geolocation.ErrorMessage.Header"))
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.errorCode === "softGeolocation"
                      ? _c("h1", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("softGeolocation.ErrorMessage.Header")
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.errorCode === "softGeolocationRedirect" ||
                    (_vm.message.errorCode === "hardGeolocationRedirect" &&
                      _vm.message.params.locationSuccess)
                      ? _c("h1", { class: [_vm.message.errorCode] }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "softGeolocationRedirect.infoMessage.Header"
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.errorCode === "hardGeolocationRedirect" &&
                    !_vm.message.params.locationSuccess
                      ? _c("h1", { class: [_vm.message.errorCode] }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "hardGeolocationRedirect.infoMessage.Header"
                              )
                            )
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "geo-content" },
            [
              _c(
                "v-layout",
                { attrs: { "align-center": "" } },
                [
                  _vm.message.errorCode !== "softGeolocation" &&
                  _vm.message.errorCode !== "softGeolocationRedirect" &&
                  _vm.message.errorCode !== "hardGeolocationRedirect"
                    ? _c("v-flex", [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Geolocation.ErrorCode." +
                                  _vm.message.errorCode +
                                  "." +
                                  _vm.state
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm.message.errorCode === 612 ||
                        _vm.message.errorCode === 615
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "gc-link",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.pluginDownload()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("GeoComply.client.pluginDownload")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.message.errorCode === 615
                                ? _c(
                                    "p",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Geolocation.ErrorCode.Note")
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "geo-suggestion" }, [
                          _vm._v(
                            _vm._s(_vm.$t("Geolocation.ErrorCode.suggestion"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.message.errorCode === "softGeolocation"
                    ? _c("v-flex", [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Geolocation.ErrorCode." + _vm.message.errorCode
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "softGeolocationLinks" }, [
                          _c("div", { staticClass: "state-wrapper" }, [
                            _c("h2", { staticClass: "state-link" }, [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.goToSite("NJ")
                                    }
                                  }
                                },
                                [_vm._v("New Jersey")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("h2", { staticClass: "state-link" }, [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.goToSite("WV")
                                    }
                                  }
                                },
                                [_vm._v("West Virginia")]
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.message.errorCode === "softGeolocationRedirect"
                    ? _c("v-flex", [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("softGeolocationRedirect.infoMessage.Text")
                            )
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.message.errorCode !== "softGeolocation" &&
          _vm.message.errorCode !== "hardGeolocationRedirect"
            ? _c("div", { staticClass: "geo-content" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _vm.message.errorCode !== "softGeolocationRedirect"
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "primary-btn-blue",
                            attrs: { block: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.closeDialog()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("Geolocation.ErrorMessage.OK"))
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.errorCode === "softGeolocationRedirect"
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "primary-btn-blue",
                            attrs: { block: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.goToRedirect(
                                  _vm.message.pathAndState.stateISO
                                )
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Geolocation.ErrorMessage.Continue")
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "nothx" }, [
                      _vm.message.errorCode === "softGeolocationRedirect"
                        ? _c(
                            "a",
                            {
                              staticClass: "app-btn",
                              on: {
                                click: function($event) {
                                  return _vm.closeDialog()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Geolocation.ErrorMessage.NoThx"))
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.message.errorCode === "hardGeolocationRedirect"
            ? _c(
                "div",
                { staticClass: "geo-content" },
                [
                  _c("v-flex", [
                    _vm.message.params.locationSuccess
                      ? _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "hardGeolocationRedirect.infoMessage.Text." +
                                  _vm.message.params.redirectTo
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.message.params.locationSuccess
                      ? _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "hardGeolocationRedirect.infoMessage.FailedText." +
                                  _vm.state
                              )
                            )
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-btn-blue",
                          attrs: { block: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goToSite(_vm.message.params.redirectTo)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Geolocation.ErrorMessage.Continue")
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "nothx" }, [
                        _c(
                          "a",
                          {
                            staticClass: "app-btn",
                            on: {
                              click: function($event) {
                                return _vm.closeDialog()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Geolocation.ErrorMessage.NoThx." +
                                    _vm.message.params.redirectTo
                                )
                              )
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3410f8f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3410f8f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/GeolocationMessage.vue
// module id = null
// module chunks = 